import React from 'react';

export interface InputProps {
    type: 'text' | 'number' | 'password' | 'email' | 'tel' | 'url';
    className?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    enterKeyHint?: 'enter' | 'done' | 'go' | 'next' | 'previous' | 'search' | 'send';
}

const Input: React.FC<InputProps & React.HTMLProps<HTMLInputElement>> = ({ className, onChange, type, ...props }) => {
    return <input type={type} className={className} onChange={onChange} {...props} />;
};

export default Input;
